import React from "react";

const StepTracker = ({ currentStep, steps }) => {
  return (
    <div className="w-full mb-6">
      {/* Top Progress Bar */}
      <div className="relative w-full border-t border-gray-300">
        <div
          className="absolute top-0 left-0 h-0.5 bg-sky-500 transition-all duration-300"
          style={{
            width: `${(currentStep / (steps.length - 1)) * 100}%`,
          }}
        />
        <div className="flex justify-between items-center -mt-1">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-sm w-full"
            >
              <div
                className={`w-3 h-3 rounded-full ${
                  index <= currentStep ? "bg-sky-500" : "bg-gray-300"
                }`}
              />
              <span
                className={`mt-1 ${
                  index === currentStep
                    ? "text-black font-semibold"
                    : "text-gray-500"
                }`}
              >
                {step}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepTracker;
